import { useNavigate } from "react-router-dom";
import { FiShield, FiArrowLeft } from "react-icons/fi";
import { useApp } from "../context/AppContext";

const ROLE_HOME = {
    superadmin: "/superadmin",
    admin: "/dashboard",
    teacher: "/teacher",
    student: "/student",
    parent: "/parent",
    accountant: "/accountant",
    librarian: "/librarian",
    warden: "/warden",
    clerk: "/clerk",
    storekeeper: "/storekeeper",
};

export default function Unauthorized() {
    const navigate = useNavigate();
    const { role } = useApp();

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "var(--bg)",
                padding: "1rem",
            }}
        >
            <div style={{ textAlign: "center", maxWidth: 360 }}>
                <div
                    style={{
                        width: 60,
                        height: 60,
                        borderRadius: 18,
                        background: "#fee2e2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 1.25rem",
                    }}
                >
                    <FiShield size={28} color="#dc2626" />
                </div>
                <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
                    Access Denied
                </h1>
                <p
                    style={{
                        fontSize: 13.5,
                        color: "var(--text-muted)",
                        lineHeight: 1.6,
                        marginBottom: "1.5rem",
                    }}
                >
                    You don't have permission to view this page.
                </p>
                <button
                    className="btn btn-outline"
                    onClick={() => navigate(ROLE_HOME[role] || "/")}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "0.4rem",
                    }}
                >
                    <FiArrowLeft size={14} /> Go to my Dashboard
                </button>
            </div>
        </div>
    );
}
